import { useEffect, useState } from "react"
import { useFetchPathNormativitiesQuery } from "../../../../../api/rtk/base/slices/diagnosticsApiSlice"
import { PathNormativitiesChart } from "../../../../../widgets/diagnostics/pathNormativitiesChart";
import PathNormativitiesChartSkeleton from "../../../../../widgets/diagnostics/pathNormativitiesChart/PathNormativitiesChartSkeleton";

type PathNormativitiesTabPanelProps = {
    pathId: string
}

const diagnosticYearDescendingSort = (a,b) => b?.DiagnosticYear - a?.DiagnosticYear

export function PathNormativitiesTabPanelContent({ pathId }: PathNormativitiesTabPanelProps) {

    const currentYear = new Date().getFullYear();
    const lastFiveYears = Array.from({ length: 5 }, (_, index) => currentYear - index);
    const diagnosticYearFilterString = `(${lastFiveYears.map((year: any) => `DiagnosticYear eq ${year}`).join(' or ')})`
    const [pathNormativitiesChartsData, setPathNormativitiesChartsData] = useState<any>([])

    const {
        data: pathNormativities,
        isFetching: pathNormativitiesAreFetching,
        isError: errorPathNormativities
    } = useFetchPathNormativitiesQuery({ filterStringArray: [`PathId eq ${pathId}`, diagnosticYearFilterString] })

    useEffect(() => {
        if (pathNormativities) {
            setPathNormativitiesChartsData(pathNormativities.value.toSorted(diagnosticYearDescendingSort))
        }
    }, [pathNormativities])

    return (
        <div className="path-normativities-tab-panel-content">
            {pathNormativitiesAreFetching
                ?
                <PathNormativitiesChartSkeleton />
                :
                <> {pathNormativitiesChartsData.length > 0
                    ?
                    <>
                        {pathNormativitiesChartsData.map((pathNormativitiesChartData: any) => <PathNormativitiesChart data={pathNormativitiesChartData} />)}
                    </>
                    :
                    <>Отсутствует информация о техническом состоянии дороги.</>
                }
                </>
            }
        </div>
    )
}
